"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SavingsAndPromosState_1 = require("./SavingsAndPromosState");
var styles = require("./SavingsAndPromos.scss");
var icons = require("../../../styles/ccc-icons-cart.scss");
var utils_1 = require("@idp/ui-components/utils");
var CartUtilFunctions_1 = require("../../../utils/CartUtilFunctions");
var ReportingService_1 = require("../../../api/ReportingService");
var CartUtils = require("../../../utils/CartUtilFunctions");
var components_1 = require("@idp/duc/components");
var UtilityFunctions_1 = require("../../../utils/UtilityFunctions");
var RetailerOffer_1 = require("../RetailerOffer/RetailerOffer");
var SavingsAndPromos = /** @class */ (function (_super) {
    __extends(SavingsAndPromos, _super);
    function SavingsAndPromos(props) {
        var _this = _super.call(this, props) || this;
        _this.yourSavingsData = {};
        _this.autoApplyCoupon = {
            couponCode: '',
        };
        _this.isSavingsAndPromosPanel = false;
        _this.titleText = '';
        _this.state = new SavingsAndPromosState_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.showSavingsAndPromos = _this.showSavingsAndPromos.bind(_this);
        _this.savingsAndPromosPanel = _this.savingsAndPromosPanel.bind(_this);
        _this.expandAndCollapse = _this.expandAndCollapse.bind(_this);
        _this.showExpandView = _this.showExpandView.bind(_this);
        _this.showMonthlySaving = _this.showMonthlySaving.bind(_this);
        _this.showOneTimeSaving = _this.showOneTimeSaving.bind(_this);
        _this.filterInfo = _this.filterInfo.bind(_this);
        _this.showRetailerOffer = _this.showRetailerOffer.bind(_this);
        return _this;
    }
    SavingsAndPromos.prototype.componentDidMount = function () {
        this.filterInfo();
    };
    SavingsAndPromos.prototype.render = function () {
        if (this.state.showPanel) {
            this.titleText = this.props.data && this.props.data.panelContent && this.props.data.panelContent.panelLabel;
            return (React.createElement("div", null,
                React.createElement("div", { className: styles.solidlineGrey }),
                this.showSavingsAndPromos()));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    SavingsAndPromos.prototype.showRetailerOffer = function (losg) {
        var _a, _b, _c, _d;
        var rewardPromotion;
        this.payload = (_a = this.props.data) === null || _a === void 0 ? void 0 : _a.payLoad;
        var promotion = (_c = (_b = this.payload) === null || _b === void 0 ? void 0 : _b.wirelessCart) === null || _c === void 0 ? void 0 : _c.promotions;
        var retailer = (_d = (promotion)) === null || _d === void 0 ? void 0 : _d.map(function (promo) {
            var _a;
            if (rewardPromotion) {
                return;
            }
            else {
                if (((_a = promo === null || promo === void 0 ? void 0 : promo.promotionType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'REWARD' && (promo === null || promo === void 0 ? void 0 : promo._dealerPromotion)) {
                    rewardPromotion = promo;
                    return React.createElement(RetailerOffer_1.default, { isReawardCard: true, losg: losg, promotion: rewardPromotion });
                }
            }
        });
        return React.createElement("div", null, retailer);
    };
    SavingsAndPromos.prototype.showSavingsAndPromos = function () {
        if (this.props.data && this.props.data.payLoad) {
            this.payload = this.props.data.payLoad;
            this.yourSavingsData.totalMonthlySavings = this.props.data.monthlyInfo &&
                this.props.data.monthlyInfo.totalMonthlySavings;
            this.yourSavingsData.totalOneTimeSavings = this.props.data.oneTimeInfo &&
                this.props.data.oneTimeInfo.totalOneTimeSavings;
        }
        if (this.yourSavingsData.totalMonthlySavings || this.yourSavingsData.totalOneTimeSavings) {
            this.isSavingsAndPromosPanel = true;
            return (React.createElement(React.Fragment, null, this.savingsAndPromosPanel()));
        }
        else {
            this.isSavingsAndPromosPanel = false;
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    SavingsAndPromos.prototype.expandAndCollapse = function () {
        this.setState({ isExpandedView: !this.state.isExpandedView });
        this.reportingService.fireLinkClickWithOutPageLoad(this.titleText, CartUtilFunctions_1.getLinkClickBasekUrl());
    };
    SavingsAndPromos.prototype.showExpandView = function () {
        var _this = this;
        var _a, _b;
        if (this.state.isExpandedView) {
            return (React.createElement("section", null, (_b = (_a = this.props.data) === null || _a === void 0 ? void 0 : _a.losgData) === null || _b === void 0 ? void 0 :
                _b.map(function (losgData) {
                    return _this.showRetailerOffer(losgData);
                }),
                this.showMonthlySaving(),
                this.showOneTimeSaving()));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    SavingsAndPromos.prototype.savingsAndPromosPanel = function () {
        var _this = this;
        var savingLabel = this.props.data.panelContent && this.props.data.panelContent.savingLabel || '';
        var imageStyle = [icons.cccIconCart, icons.cccIconCartSignatureBookmark].join(' ');
        var isFNCustomer = CartUtilFunctions_1.isFNIntentPresent() || CartUtilFunctions_1.isFNUserWithConsumerLine();
        var isIRUCustomer = this.props && this.props.data && this.props.data.payLoad &&
            this.props.data.payLoad.b2bDetail && this.props.data.payLoad.b2bDetail.FAN && !CartUtils.isSMBCustomer();
        return (React.createElement("section", null,
            React.createElement("div", { className: styles.panelContent },
                React.createElement("div", { className: styles.titleContainer },
                    React.createElement("div", { className: styles.title },
                        this.props.data.payLoad.enableSignatureEnhancedExperience && isIRUCustomer && !isFNCustomer &&
                            React.createElement("span", { className: styles.iconBookmark32 }, (CartUtils.isAppreciationOfferPresent()) ?
                                React.createElement("img", { className: styles.appreciationIcon, src: 'https://www.att.com/idpassets/global/icons/svg/retail-financial/functional-icon_financial-security-filled_32.svg', alt: 'appreciationIcon' }) : React.createElement("i", { "aria-label": "Icon", className: imageStyle })),
                        React.createElement("h2", { className: styles.titleText },
                            " ",
                            this.titleText,
                            " ")),
                    React.createElement("div", { "aria-label": this.titleText + " ExpandAndCollapse" },
                        React.createElement(components_1.Link, { kind: "withPrependIcon", testId: utils_1.default('Cart', this.titleText), 
                            // tslint:disable-next-line: jsx-no-lambda
                            onClick: function () { _this.expandAndCollapse(); }, icon: this.props && this.props.data && this.props.data.disableIcon
                                ? React.createElement(React.Fragment, null) : this.state.isExpandedView ?
                                React.createElement(components_1.IconSvg, { ariaLabel: "Cart " + this.titleText, size: 16, svgNodeStr: UtilityFunctions_1.GET_ICON_SVG.UP }) :
                                React.createElement(components_1.IconSvg, { ariaLabel: "Cart " + this.titleText, size: 16, svgNodeStr: UtilityFunctions_1.GET_ICON_SVG.DOWN }) }))),
                React.createElement("h5", { className: styles.titleContent },
                    " ",
                    savingLabel,
                    " ")),
            this.showExpandView()));
    };
    SavingsAndPromos.prototype.showMonthlySaving = function () {
        if (this.yourSavingsData.totalMonthlySavings && this.yourSavingsData.totalMonthlySavings > 0 &&
            this.props.data && this.props.data.monthlyInfo && this.props.data.monthlyInfo.monthlySavingsContent) {
            return (React.createElement("div", null, this.props.data.monthlyInfo.monthlySavingsContent));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    SavingsAndPromos.prototype.showOneTimeSaving = function () {
        if (this.yourSavingsData.totalOneTimeSavings && this.yourSavingsData.totalOneTimeSavings > 0 &&
            this.props.data && this.props.data.oneTimeInfo && this.props.data.oneTimeInfo.oneTimeSavingsContent) {
            return (React.createElement("div", null, this.props.data.oneTimeInfo.oneTimeSavingsContent));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    SavingsAndPromos.prototype.filterInfo = function () {
        if (this.props.data && this.props.data.payLoad && this.props.data.showPanel) {
            this.payload = this.props.data.payLoad;
            var expandedView = this.props.options && this.props.options.expandedView;
            this.yourSavingsData.totalMonthlySavings = this.props.data.monthlyInfo &&
                this.props.data.monthlyInfo.totalMonthlySavings;
            this.yourSavingsData.totalOneTimeSavings = this.props.data.oneTimeInfo &&
                this.props.data.oneTimeInfo.totalOneTimeSavings;
            if (this.props.data.showPanel) {
                this.setState({ showPanel: true, isExpandedView: expandedView });
            }
            else {
                this.setState({ showPanel: false });
            }
        }
    };
    return SavingsAndPromos;
}(React.Component));
exports.default = SavingsAndPromos;
//# sourceMappingURL=SavingsAndPromos.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/SavingsAndPromos/SavingsAndPromos.js
// module id = 783
// module chunks = 8